export default {
    isGridShow: state => state.gridIsShow,
    isFormShow: state => state.formIsShow,

    getAdditionalTableConfig: state => state.additionalTableConfig,
    getActions: state => state.actions,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields
}